import React from 'react';
import PropTypes from 'prop-types';
import AutoCompleteFilter from 'components/list/Filters/types/AutoCompleteFilter';
import rolesHelper from 'helpers/roles';

const ProviderFilter = (props) => {
    return (
        <AutoCompleteFilter
            { ...props }
            label='filters.components.providerId.label'
            reference='accounts'
            searchBy='name'
        />
    );
};

ProviderFilter.defaultProps = {
    options: {
        fullWidth: true,
    },
    optionValue: 'id',
    searchParams: {
        role_id: [
            rolesHelper.getProviderRoleId(),
        ],
        size: '12',
        sort_by: 'name',
        sort_direction: 'asc',
    },
    source: 'provider_id',
};

ProviderFilter.propTypes = {
    options: PropTypes.shape({
        fullWidth: PropTypes.bool,
        floatingLabelFixed: PropTypes.bool,
    }),
    optionValue: PropTypes.string,
    searchParams: PropTypes.shape({
        role_id: PropTypes.arrayOf(PropTypes.number),
        size: PropTypes.string,
        sort_by: PropTypes.string,
        sort_direction: PropTypes.oneOf([
            'asc',
            'desc',
        ]),
    }),
    source: PropTypes.string,
};

export default ProviderFilter;


// WEBPACK FOOTER //
// ./src/components/list/Filters/types/ProviderFilter.js